import typeCheck from 'common/util/typeCheck';

import { SR_API_ACTION_HOUSEHOLD_UPDATE_APPLICATION } from 'api/actionTypes';

import updateLocalApplication from 'client/actions/HouseholdApplication/updateLocalApplication';

export default async function updateApplication(
  { state, apiClient },
  { applicationId, stepId, updates },
) {
  typeCheck('applicationId::PositiveNumber', applicationId);
  typeCheck('stepId::Maybe NonEmptyString', stepId);
  typeCheck('updates::NonEmptyObject', updates);

  const fieldIds = Object.keys(updates);

  for (const fieldId of fieldIds) {
    state.set(['household', 'applicationsById', applicationId, fieldId], updates[fieldId]);
  }

  updateLocalApplication({ state }, { applicationId, updates });
  state.commit();

  return apiClient.postWithState({
    action: SR_API_ACTION_HOUSEHOLD_UPDATE_APPLICATION,
    queryId: `${String(applicationId)}:${fieldIds.join('_')}`,
    state: state,
    payload: {
      applicationId,
      stepId,
      updates,
    },
  });
}
